import { CloudType } from '../../types'
import type { FlyOutListingData } from '../../types/flyout'
import type { FlyOutListingUserType } from '../../types/external'
import type { FlyoutCloudSettings } from '../../modules/flyOutOnboarding/types'
import type { FlyOutCloudSettingsFormValues } from './types'

export const mapFlyoutListingDataToFlyoutCloudSettings = (
  listingData: FlyOutListingData,
  accountId?: string
): FlyoutCloudSettings => ({
  cloudProvider: CloudType.AWS,
  cloudAccountId: listingData.awsAccountId || '',
  cloudAccountName: listingData.awsAccountName || '',
  cloudRoleArn: listingData.sellerMetadata?.awsRoleArn || '',
  cloudCasS3BucketName: listingData.sellerMetadata?.awsCasS3BucketName || '',
  cloudCasSnsTopic: listingData.sellerMetadata?.awsCasSnsTopic || '',
  cloudKmsKeyArn: listingData.sellerMetadata?.awsKmsKeyArn || '',
  connectionTested: false,
  formFilled: true,
  testConnectionStatus: 'standBy',
  currencies: listingData.currencies || [],
  formUpdated: true,
  countryRegistered: listingData.countryRegistered || '',
  isOwnS3Bucket: listingData.isOwnS3Bucket ?? false,
  automation: !(listingData.isOwnS3Bucket ?? false),
  stackType:
    listingData.stackType === 'terraform' ? 'terraform' : 'cloudformation',
  cloudExternalId: accountId || '',
  terraformConnectionValidated:
    listingData.terraformConnectionValidated ?? false,
})

export const mapFlyoutCloudSettingsToFlyoutListingData = (
  cloudSettings: FlyoutCloudSettings,
  sellerType: string[],
  origin: FlyOutListingUserType | string
): FlyOutCloudSettingsFormValues => ({
  origin: origin || ('NEW' as FlyOutListingUserType),
  sellerMetadata: {
    awsRoleArn: cloudSettings.cloudRoleArn || '',
    awsCasS3BucketName: cloudSettings.cloudCasS3BucketName || '',
    awsCasSnsTopic: cloudSettings.cloudCasSnsTopic || '',
    awsKmsKeyArn: cloudSettings.cloudKmsKeyArn || '',
  },
  awsAccountId: cloudSettings.cloudAccountId || '',
  awsAccountName: cloudSettings.cloudAccountName || '',
  currencies: cloudSettings.currencies || [],
  sellerType: sellerType || [],
  countryRegistered: cloudSettings.countryRegistered || '',
  isOwnS3Bucket: cloudSettings.isOwnS3Bucket ?? false,
  stackType:
    cloudSettings.stackType === 'terraform' ? 'terraform' : 'cloudformation',
  cloudExternalId: cloudSettings.cloudExternalId || '',
  terraformConnectionValidated:
    cloudSettings.terraformConnectionValidated ?? false,
})
